// Angular
import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
// Layout
import {LayoutConfigService, ToggleOptions} from '../../../core/_base/layout';
import {HtmlClassService} from '../html-class.service';

@Component({
  selector: 'kt-brand',
  templateUrl: './brand.component.html',
})
export class BrandComponent implements OnInit, AfterViewInit {
  // Public properties
  headerLogo = '';
  brandClasses = '';
  asideSelfMinimizeToggle = true;
  isReduce = true;
  @Output() reduceEvent = new EventEmitter<boolean>();

  toggleOptions: ToggleOptions = {
    target: 'kt_body',
    targetState: 'aside-minimize',
    toggleState: 'active'
  };

  /**
   * Component constructor
   *
   * @param layoutConfigService: LayoutConfigService
   * @param htmlClassService: HtmlClassService
   */
  constructor(private layoutConfigService: LayoutConfigService, public htmlClassService: HtmlClassService) {
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    this.headerLogo = this.getAsideLogo();
    this.brandClasses = this.htmlClassService.getClasses('brand', true).toString();
    this.asideSelfMinimizeToggle = this.layoutConfigService.getConfig('aside.self.minimize.toggle');
  }

  /**
   * On after view init
   */
  ngAfterViewInit(): void {
  }

  getAsideLogo() {
    let result = 'logo1.png';
    const brandSelfTheme = this.layoutConfigService.getConfig('brand.self.theme') || '';
    if (brandSelfTheme === 'light') {
      result = 'logo.png';
    }
    return `./assets/media/logos/${result}`;
  }

  toggleAsideClick() {
    this.isReduce = !this.isReduce;
    this.reduceEvent.emit(this.isReduce);
    document.body.classList.toggle('aside-minimize');
  }
}
